"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: bnpl/loan-eligibility.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fbnpl%2Floan-eligibility.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.loanEligibilityIneligibleReasonToJSON = exports.loanEligibilityIneligibleReasonFromJSON = exports.LoanEligibilityIneligible = exports.LoanEligibilityEligible = exports.LoanEligibility = exports.LoanEligibilityIneligibleReason = void 0;
const account_1 = require("../account/account");
const protobufPackage = 'com.step.bnpl.proto';
var LoanEligibilityIneligibleReason;
(function (LoanEligibilityIneligibleReason) {
    LoanEligibilityIneligibleReason["INVALID_ELIGIBILITY_REASON"] = "INVALID_ELIGIBILITY_REASON";
    LoanEligibilityIneligibleReason["TOO_OLD"] = "TOO_OLD";
    LoanEligibilityIneligibleReason["TOO_SMALL"] = "TOO_SMALL";
    LoanEligibilityIneligibleReason["LARGER_THAN_PURCHASE"] = "LARGER_THAN_PURCHASE";
    LoanEligibilityIneligibleReason["DISPUTED"] = "DISPUTED";
    LoanEligibilityIneligibleReason["REFUNDED"] = "REFUNDED";
    LoanEligibilityIneligibleReason["INVALID_CURRENCY"] = "INVALID_CURRENCY";
    LoanEligibilityIneligibleReason["EXCEEDS_INSTALLMENT_LIMIT"] = "EXCEEDS_INSTALLMENT_LIMIT";
    LoanEligibilityIneligibleReason["ALREADY_LOANED"] = "ALREADY_LOANED";
    LoanEligibilityIneligibleReason["DECLINED"] = "DECLINED";
    LoanEligibilityIneligibleReason["UNSUPPORTED_MERCHANT"] = "UNSUPPORTED_MERCHANT";
    LoanEligibilityIneligibleReason["UNSECURED_PURCHASE"] = "UNSECURED_PURCHASE";
    LoanEligibilityIneligibleReason["UNRECOGNIZED"] = "UNRECOGNIZED";
})(LoanEligibilityIneligibleReason || (exports.LoanEligibilityIneligibleReason = LoanEligibilityIneligibleReason = {}));
function createBaseLoanEligibility() {
    return { eligible: undefined, ineligible: undefined };
}
exports.LoanEligibility = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.eligible)) {
            message.eligible = exports.LoanEligibilityEligible.fromJSON(object.eligible);
        }
        if (isSet(object.ineligible)) {
            message.ineligible = exports.LoanEligibilityIneligible.fromJSON(object.ineligible);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.eligible !== undefined) {
            obj.eligible = exports.LoanEligibilityEligible.toJSON(message.eligible);
        }
        if (message.ineligible !== undefined) {
            obj.ineligible = exports.LoanEligibilityIneligible.toJSON(message.ineligible);
        }
        return obj;
    },
    create(base) {
        return exports.LoanEligibility.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLoanEligibility();
        message.eligible = (object.eligible !== undefined && object.eligible !== null)
            ? exports.LoanEligibilityEligible.fromPartial(object.eligible)
            : undefined;
        message.ineligible = (object.ineligible !== undefined && object.ineligible !== null)
            ? exports.LoanEligibilityIneligible.fromPartial(object.ineligible)
            : undefined;
        return message;
    },
};
function createBaseLoanEligibilityEligible() {
    return { loan: account_1.InstallmentLoan.fromPartial({}), requiresCreditPullAgreement: false };
}
exports.LoanEligibilityEligible = {
    fromJSON(object) {
        const message = {
            loan: isSet(object.loan)
                ? account_1.InstallmentLoan.fromJSON(object.loan)
                : account_1.InstallmentLoan.fromPartial({}),
        };
        if (isSet(object.requiresCreditPullAgreement)) {
            message.requiresCreditPullAgreement = globalThis.Boolean(object.requiresCreditPullAgreement);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.loan !== undefined) {
            obj.loan = account_1.InstallmentLoan.toJSON(message.loan);
        }
        if (message.requiresCreditPullAgreement !== undefined &&
            message.requiresCreditPullAgreement !== false) {
            obj.requiresCreditPullAgreement = message.requiresCreditPullAgreement;
        }
        return obj;
    },
    create(base) {
        return exports.LoanEligibilityEligible.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLoanEligibilityEligible();
        message.loan = (object.loan !== undefined && object.loan !== null)
            ? account_1.InstallmentLoan.fromPartial(object.loan)
            : account_1.InstallmentLoan.fromPartial({});
        message.requiresCreditPullAgreement = object.requiresCreditPullAgreement ?? false;
        return message;
    },
};
function createBaseLoanEligibilityIneligible() {
    return { reason: LoanEligibilityIneligibleReason.INVALID_ELIGIBILITY_REASON };
}
exports.LoanEligibilityIneligible = {
    fromJSON(object) {
        const message = {
            reason: isSet(object.reason)
                ? loanEligibilityIneligibleReasonFromJSON(object.reason)
                : LoanEligibilityIneligibleReason.INVALID_ELIGIBILITY_REASON,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reason !== LoanEligibilityIneligibleReason.INVALID_ELIGIBILITY_REASON) {
            obj.reason = loanEligibilityIneligibleReasonToJSON(message.reason);
        }
        return obj;
    },
    create(base) {
        return exports.LoanEligibilityIneligible.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLoanEligibilityIneligible();
        message.reason = object.reason ?? LoanEligibilityIneligibleReason.INVALID_ELIGIBILITY_REASON;
        return message;
    },
};
function loanEligibilityIneligibleReasonFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ELIGIBILITY_REASON':
            return LoanEligibilityIneligibleReason.INVALID_ELIGIBILITY_REASON;
        case 1:
        case 'TOO_OLD':
            return LoanEligibilityIneligibleReason.TOO_OLD;
        case 2:
        case 'TOO_SMALL':
            return LoanEligibilityIneligibleReason.TOO_SMALL;
        case 3:
        case 'LARGER_THAN_PURCHASE':
            return LoanEligibilityIneligibleReason.LARGER_THAN_PURCHASE;
        case 4:
        case 'DISPUTED':
            return LoanEligibilityIneligibleReason.DISPUTED;
        case 5:
        case 'REFUNDED':
            return LoanEligibilityIneligibleReason.REFUNDED;
        case 8:
        case 'INVALID_CURRENCY':
            return LoanEligibilityIneligibleReason.INVALID_CURRENCY;
        case 9:
        case 'EXCEEDS_INSTALLMENT_LIMIT':
            return LoanEligibilityIneligibleReason.EXCEEDS_INSTALLMENT_LIMIT;
        case 10:
        case 'ALREADY_LOANED':
            return LoanEligibilityIneligibleReason.ALREADY_LOANED;
        case 11:
        case 'DECLINED':
            return LoanEligibilityIneligibleReason.DECLINED;
        case 12:
        case 'UNSUPPORTED_MERCHANT':
            return LoanEligibilityIneligibleReason.UNSUPPORTED_MERCHANT;
        case 13:
        case 'UNSECURED_PURCHASE':
            return LoanEligibilityIneligibleReason.UNSECURED_PURCHASE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return LoanEligibilityIneligibleReason.UNRECOGNIZED;
    }
}
exports.loanEligibilityIneligibleReasonFromJSON = loanEligibilityIneligibleReasonFromJSON;
function loanEligibilityIneligibleReasonToJSON(object) {
    switch (object) {
        case LoanEligibilityIneligibleReason.INVALID_ELIGIBILITY_REASON:
            return 'INVALID_ELIGIBILITY_REASON';
        case LoanEligibilityIneligibleReason.TOO_OLD:
            return 'TOO_OLD';
        case LoanEligibilityIneligibleReason.TOO_SMALL:
            return 'TOO_SMALL';
        case LoanEligibilityIneligibleReason.LARGER_THAN_PURCHASE:
            return 'LARGER_THAN_PURCHASE';
        case LoanEligibilityIneligibleReason.DISPUTED:
            return 'DISPUTED';
        case LoanEligibilityIneligibleReason.REFUNDED:
            return 'REFUNDED';
        case LoanEligibilityIneligibleReason.INVALID_CURRENCY:
            return 'INVALID_CURRENCY';
        case LoanEligibilityIneligibleReason.EXCEEDS_INSTALLMENT_LIMIT:
            return 'EXCEEDS_INSTALLMENT_LIMIT';
        case LoanEligibilityIneligibleReason.ALREADY_LOANED:
            return 'ALREADY_LOANED';
        case LoanEligibilityIneligibleReason.DECLINED:
            return 'DECLINED';
        case LoanEligibilityIneligibleReason.UNSUPPORTED_MERCHANT:
            return 'UNSUPPORTED_MERCHANT';
        case LoanEligibilityIneligibleReason.UNSECURED_PURCHASE:
            return 'UNSECURED_PURCHASE';
        case LoanEligibilityIneligibleReason.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.loanEligibilityIneligibleReasonToJSON = loanEligibilityIneligibleReasonToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=loan-eligibility.js.map